import React from 'react'

// Behaelter fuer Inhalt, den Redakteure im Backoffice schreiben (#95).
//
// Eine Klasse, eine Regelmenge (scss/_richText.scss), vier Orte: Sidebar der
// Messeseite, Anzeigentext einer Stellenanzeige, Startbildschirm der Job-Matrix.
// Ohne den gemeinsamen Behaelter muesste jeder Screen selbst wissen, wie eine
// Aufzaehlung aussieht — und keiner wusste es.
//
// Zwei Formen, weil der Inhalt in zwei Formen ankommt: als HTML-Zeichenkette aus
// dem WYSIWYG-Feld und als Elemente, die react-markdown aus dem Anzeigentext
// baut.
const RichText = ({
    html = false,
    className = '',
    children
}) => {
    const klassen = ['jm-rich-text', className].filter(Boolean).join(' ')

    return false !== html
        ? <div className={klassen} dangerouslySetInnerHTML={{ __html: html }} />
        : <div className={klassen}>{children}</div>
}

export default RichText
